/* =====================================================
   HEADER – FIXED SIEMPRE VISIBLE (SHOPIFY SAFE)
===================================================== */
const header = document.getElementById('spHeader');
const menuBtn = document.getElementById('spMenuBtn');
const mobileMenu = document.getElementById('spMobileMenu');
const closeMenu = document.getElementById('spCloseMenu');
const scrollLinks = document.querySelectorAll('[data-scroll]');
const navItems = document.querySelectorAll('.sp-nav-item');
const searchBtn = document.querySelector('.sp-search-btn');

// Header: solo cambia estilo visual al hacer scroll
window.addEventListener('scroll', () => {
  if (!header) return;
  header.classList.toggle('scrolled', window.scrollY > 20);
});

/* ========= SCROLL SUAVE + ACTIVE AL CLICK ========= */
scrollLinks.forEach(link => {
  link.addEventListener('click', () => {
    const targetId = link.dataset.scroll;
    const target = document.getElementById(targetId);
    if (!target || !header) return;

    const offset = header.offsetHeight;

    window.scrollTo({
      top: target.offsetTop - offset,
      behavior: 'smooth'
    });

    // ACTIVE TAB (línea naranja)
    navItems.forEach(i => i.classList.remove('active'));
    if (link.classList.contains('sp-nav-item')) {
      link.classList.add('active');
    }

    mobileMenu?.classList.remove('open');
  });
});

// Menú móvil
menuBtn?.addEventListener('click', () => {
  mobileMenu?.classList.add('open');
});

closeMenu?.addEventListener('click', () => {
  mobileMenu?.classList.remove('open');
});


/* ========= ACTIVE TAB SEGÚN SCROLL (PRO UX) ========= */
const sectionMap = [
  { id: 'hero', label: 'Inicio' },
  { id: 'videos', label: 'Creators Videos' },
  { id: 'kits', label: 'Exclusive Kits' },
  { id: 'community', label: 'Community' },
  { id: 'feedback', label: '1-to-1 Feedback' },
  { id: 'benefits', label: 'Benefits' }
];

window.addEventListener('scroll', () => {
  if (!header) return;

  const scrollPos = window.scrollY + header.offsetHeight + 80;

  sectionMap.forEach(section => {
    const el = document.getElementById(section.id);
    if (!el) return;

    const top = el.offsetTop;
    const bottom = top + el.offsetHeight;

    if (scrollPos >= top && scrollPos < bottom) {
      navItems.forEach(i => i.classList.remove('active'));
      const activeItem = [...navItems].find(
        i => i.textContent.trim() === section.label
      );
      activeItem?.classList.add('active');
    }
  });
});


/* =====================================================
   HERO – Carrusel automático + barras
===================================================== */
const slides = document.querySelectorAll('.sp-hero-slide');
const bars = document.querySelectorAll('.sp-hero-progress .bar');
const heroTitle = document.querySelector('.sp-hero-title');
const heroDesc = document.querySelector('.sp-hero-desc');
const heroBtn = document.querySelector('.sp-hero-btn');

let currentHero = 0;
const heroDuration = 6000;

function showHeroSlide(index) {
  if (!slides.length) return;

  slides.forEach(s => s.classList.remove('active'));
  bars.forEach(b => {
    b.classList.remove('active');
    b.style.animation = 'none';
    b.offsetHeight;
  });

  const slide = slides[index];
  slide.classList.add('active');

  heroTitle.textContent = slide.dataset.title || '';
  heroDesc.textContent = slide.dataset.desc || '';
  heroBtn.onclick = () => {
    location.href = slide.dataset.link || '#';
  };

  if (bars[index]) {
    bars[index].classList.add('active');
    bars[index].style.animationDuration = heroDuration + 'ms';
  }
}

if (slides.length > 1) {
  setInterval(() => {
    currentHero = (currentHero + 1) % slides.length;
    showHeroSlide(currentHero);
  }, heroDuration);
}

showHeroSlide(currentHero);


/* =====================================================
   CREATORS VIDEOS – Scroll horizontal con flechas
===================================================== */
document.querySelectorAll('.sp-row-wrapper').forEach(wrapper => {
  const track = wrapper.querySelector('.sp-row-track');
  const leftArrow = wrapper.querySelector('.sp-arrow.left');
  const rightArrow = wrapper.querySelector('.sp-arrow.right');

  if (!track) return;

  leftArrow?.addEventListener('click', () => {
    track.scrollBy({
      left: -track.clientWidth * 0.8,
      behavior: 'smooth'
    });
  });

  rightArrow?.addEventListener('click', () => {
    track.scrollBy({
      left: track.clientWidth * 0.8,
      behavior: 'smooth'
    });
  });
});


/* =====================================================
   SEARCH – Buscador avanzado (overlay)
===================================================== */
const searchOverlay = document.getElementById('spSearch');
const searchClose = document.getElementById('spSearchClose');
const searchInput = document.getElementById('spSearchInput');

searchBtn?.addEventListener('click', () => {
  searchOverlay?.classList.add('open');
  setTimeout(() => searchInput?.focus(), 100);
});

searchClose?.addEventListener('click', () => {
  searchOverlay?.classList.remove('open');
  if (searchInput) searchInput.value = '';
});

// Cerrar buscador con ESC
window.addEventListener('keydown', e => {
  if (e.key === 'Escape' && searchOverlay?.classList.contains('open')) {
    searchOverlay.classList.remove('open');
    if (searchInput) searchInput.value = '';
  }
});


/* =====================================================
   CREATORS VIDEOS – TAP EN MOBILE (NUEVO)
===================================================== */
document.querySelectorAll('.sp-video-card').forEach(card => {
  card.addEventListener('click', e => {
    // Solo mobile / tablet
    if (window.innerWidth > 768) return;

    // Si no está activo → activar overlay
    if (!card.classList.contains('active')) {
      e.preventDefault();

      // Cerrar otros activos
      document
        .querySelectorAll('.sp-video-card.active')
        .forEach(c => c.classList.remove('active'));

      card.classList.add('active');
    }
    // Si ya está activo → deja funcionar el botón "Mirar ahora"
  });
});
